import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";

export const InfoCard = ({ label, value }) => (
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      border: "1px solid #b3ecff",
      borderRadius: "10px",
      overflow: "hidden",
      width: "100%", // responsive
    }}
  >
    {/* Left Highlight Strip */}
    <Box
      sx={{
        width: "6px",
        backgroundColor: "#a7e6ff",
        borderTopLeftRadius: "10px",
        borderBottomLeftRadius: "10px",
      }}
    />
    {/* Text Content */}
    <Box sx={{ p: 1.5 }}>
      <Typography variant="body2">{label}</Typography>
      <Typography variant="subtitle2" fontWeight={600}>
        {value}
      </Typography>
    </Box>
  </Paper>
);

InfoCard.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};
